module.exports = __webpack_public_path__ + "assets/eaba30d658a067224100e253fbfdb168.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/drop/12/ScatterOrchHit03.mp3
 ** module id = 345
 ** module chunks = 0
 **/